interface Seo {
  title?: string
  description?: string
  keywords?: string
  seo_title?: string
  seo_description?: string
  seo_keywords?: string
}

export function SEOMaker(
  domain: string,
  seo: Seo | null,
  fullPath: string,
  path: string,
): any {
  const head: any = {}
  head.link = [{ rel: 'canonical', href: `https://${domain}${path}` }]

  head.meta = [
    {
      property: 'og:type',
      content: 'website',
    },
    {
      property: 'og:url',
      content: `https://${domain}${fullPath}`,
    },
    {
      property: 'og:image',
      content: `https://${domain}/farfor-og-image.png`,
    },
  ]

  if (seo?.title) {
    head.title = seo.title
    head.meta.push({
      property: 'og:title',
      content: seo.title,
    })
  }

  if (seo?.description) {
    head.meta.push(
      {
        property: 'og:description',
        content: seo.description,
      },
      {
        hid: 'description',
        name: 'description',
        content: seo.description,
      },
    )
  }

  if (seo?.keywords) {
    head.meta.push({
      hid: 'keywords',
      name: 'keywords',
      content: seo.keywords,
    })
  }

  return head
}
